import { AccountNumberRegistrationEvent } from './AccountNumberRegistrationEvent';

export class AccountNumberRegistrationAddedEvent extends AccountNumberRegistrationEvent {}
